import styled from 'styled-components';
import { Point } from 'dragonmouse-shared/geometry';
import { ThumbnailScroller } from 'styles';

export const Frames = styled(ThumbnailScroller)`
	margin-top: 12px;
	margin-bottom: 16px;
	border-radius: 8px;
	cursor: default;
	user-select: none;
`;

interface SelectionButtonProps {
	corner: Point;
	selected: boolean;
}

export const ReadOnlyNotice = styled.div`
	padding: 12px 16px;
	text-align: center;
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	user-select: none;
`;

export const SelectionButton = styled.div<SelectionButtonProps>`
	//layout
	position: fixed;
	left: ${(props) => props.corner.x}px;
	top: ${(props) => props.corner.y}px;
	z-index: 1000;
	border: 1px solid ${({ theme }) => theme.gray[600]};
	background-color: ${({ theme, selected }) => (selected ? theme.blue[500] : theme.gray[0])};
	width: 28px;
	height: 28px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	&:hover {
		background-color: ${({ theme, selected }) => (selected ? theme.blue[500] : theme.gray[200])};
	}
`;
